<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='欢迎来到四川博物院'">

    <div>
      <div class="index-banner">
        <swiper :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback">
          <!--<div class="swiper-slide">-->
            <!--<img class="img" src="../../assets/0719-banner.jpg" @click="toMkbl" width="100%" height="100%" alt=""/>-->
          <!--</div>-->
          <!--<div class="swiper-slide">-->
            <!--<img class="img" src="../../assets/0718-banner.png" @click="toSxd" width="100%" height="100%" alt=""/>-->
          <!--</div>-->
          <!--<div class="swiper-slide">-->
            <!--<img class="img" src="https://filewc.geeker.com.cn/wcrecord/upload/baidu/20250121/h133w3fn3eb1jhm6dm34yihf274ypjn8ema1c3.gif" width="100%" height="100%" alt=""/>-->
          <!--</div>-->
          <!--<div class="swiper-slide">-->
            <!--<img class="img" src="https://filewc.geeker.com.cn/wcrecord/upload/baidu/20250121/eppfjmgh8i7mg7mszh97732wgh6zh1x1hn37f7.gif" width="100%" height="100%" alt=""/>-->
          <!--</div>-->
          <!--<div class="swiper-slide">-->
            <!--<img class="img" src="https://filewc.geeker.com.cn/temp/mr/libai002.png" width="100%" height="100%" alt=""/>-->
          <!--</div>-->
          <!--<div class="swiper-slide">-->
            <!--<img class="img" src="https://filewc.geeker.com.cn/temp/mr/libai004.png" width="100%" height="100%" alt=""/>-->
          <!--</div>-->
          <div class="swiper-slide">
            <img class="img" src="@/assets/banner-01.jpg" width="100%" height="100%" alt=""/>
            <wx-open-launch-weapp id="launch-btn1" :appid="gerData1.appid" :path="gerData1.path" @launch="onLaunch" @error="errorFun" style="position: absolute;width: 100%;height:100%;left: 0;top:0;z-index:1;">
              <script type="text/wxtag-template">
                <div class="btn" style="position: absolute;width: 100%;height:100%;left: 0;top:0;z-index:1;"></div>
              </script>
            </wx-open-launch-weapp>
          </div>
          <div class="swiper-slide" @click="toYlg">
            <img class="img" src="@/assets/banner-02.jpg" width="100%" height="100%" alt=""/>
          </div>
          <div class="swiper-slide" v-for="(item,index) in banners" :key="index">
            <img class="img" :src="item.imgurl"  @click="seeImg(item.imgurl,banners)" width="100%" height="100%" alt="">
          </div>
        </swiper>
      </div>


      <div class="spot-info box border-box spot-info1">
        <div class="left">
          <img src="https://filewc.geeker.com.cn//base64_file/20221011/gMHRApee3Ry3ShSScIfnR7JPjL7Umn3cNSUmpb.jpeg" alt="">
        </div>
        <div class="flex right">
          <p class="name">{{scenicInfo.name}}</p>
          <div class="sub">
            <span class="state s1">{{isOpenToday}}</span><span class="line"></span><span class="state">{{scenicInfo.special}}</span>
            <!--<span class="state">9:00-17:00  16:00停止入场</span>-->
          </div>
          <p class="map" @click="openMap">{{scenicInfo.address}}<span class="fr">导航<img class="fr" src="../../assets/right06.png" alt=""></span></p>
        </div>
      </div>

      <div class="spot-info box border-box">
        <div class="left">
          <img src="../../assets/icon-team1.png" alt="">
        </div>

        <div class="flex right1" style="pointer-events: none;">
          <div class="name">个人门票预约
            <p class="txt" style="margin-top: .1rem;">每日免费讲解时间：</p>
            <p class="txt">上午10:00；下午14:00</p>
            <a class="txt" style="display: block;" href="tel:65521888">咨询电话：65521888</a>
          </div>
          <span class="bt">去预约</span>
        </div>
        <wx-open-launch-weapp id="launch-btn" :appid="gerData.appid" :path="gerData.path" @launch="onLaunch" @error="errorFun" style="position: absolute;width: 100%;height:100%;left: 0;top:0;z-index:1;">
          <script type="text/wxtag-template">
            <div class="btn" style="position: absolute;width: 100%;height:100%;left: 0;top:0;z-index:1;"></div>
          </script>
        </wx-open-launch-weapp>
      </div>


      <div class="spot-info box border-box" @click="toTeam">
        <div class="left">
          <img src="../../assets/icon-team2.png" alt="">
        </div>

        <div class="flex right1">
          <div class="name">团队门票预约
            <!--<p>20人及以上预约通道</p>-->
          </div>
          <span class="bt">去预约</span>
        </div>
      </div>
      <div class="spot-info box border-box">
        <div class="left">
          <img src="../../assets/icon-01.png" alt="">
        </div>

        <div class="flex right1">
          <div class="name">大闹天宫
            <p>XR沉浸式体验展</p>
          </div>
          <span class="bt">去预约</span>
        </div>
        <wx-open-launch-weapp id="launch-btn1" :appid="gerData1.appid" :path="gerData1.path" @launch="onLaunch" @error="errorFun" style="position: absolute;width: 100%;height:100%;left: 0;top:0;z-index:1;">
          <script type="text/wxtag-template">
            <div class="btn" style="position: absolute;width: 100%;height:100%;left: 0;top:0;z-index:1;"></div>
          </script>
        </wx-open-launch-weapp>
      </div>
      <div class="spot-info box border-box" @click="toYlg">
        <div class="left">
          <img src="../../assets/icon-02.jpg" alt="">
        </div>

        <div class="flex right1">
          <div class="name">永乐宫特展
            <p class="text" style="width: 3rem">观妙入真——永乐宫的建筑艺术与传承</p>
          </div>
          <span class="bt">去预约</span>
        </div>
      </div>
      <div class="spot-info box border-box" @click="toActivity">
        <div class="left">
          <img src="../../assets/icon-team6.png" alt="">
        </div>

        <div class="flex right1">
          <div class="name">川博学苑
            <p>活动讲座预约</p>
          </div>
          <span class="bt">去预约</span>
        </div>
      </div>

      <!--
      <div class="spot-info box border-box">
        <div class="left">
          <img src="https://filewc.geeker.com.cn/temp/mr/libailogo.jpg" alt="" style="object-fit: cover;">
        </div>
        <div class="flex right1" style="pointer-events: none;">
          <div class="name">走进梵高-XR大空间购票
            <p>以身入画 沉浸式逛展</p>
          </div>
        </div>
        <wx-open-launch-weapp id="launch-btn1" :appid="gerData1.appid" :path="gerData1.path" @launch="onLaunch" @error="errorFun" style="position: absolute;width: 100%;height:100%;left: 0;top:0;z-index:1;">
          <script type="text/wxtag-template">
            <div class="btn" style="position: absolute;width: 100%;height:100%;left: 0;top:0;z-index:1;"></div>
          </script>
        </wx-open-launch-weapp>
      </div>
      -->

      <!--<div class="spot-info box border-box" @click="toSxd">-->
        <!--<div class="left">-->
          <!--<img src="../../assets/0718-icon.png" alt="">-->
        <!--</div>-->

        <!--<div class="flex right1">-->
          <!--<div class="name">重返三星堆-VR展购票预约-->
            <!--<p>古蜀王国奇幻之旅</p>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->

      <!--<div class="spot-info box border-box" @click="toMkbl">-->
        <!--<div class="left">-->
          <!--<img src="../../assets/0719-icon.jpg" alt="">-->
        <!--</div>-->

        <!--<div class="flex right1">-->
          <!--<div class="name">马可·波罗特展购票预约-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->

    </div>

    <div class="alert-box" v-if="agreementVisible">
      <div class="mask" @click="agreementVisible=false"></div>
      <div class="alert-con">
        <p class="tip-title">预约须知</p>
        <div class="agreement">
          <p>尊敬的用户：</p>
          <p style="text-indent: 2em;">感谢您使用四川博物院公众号提供的服务。为了向您提供 [门票预约 / 在线购票] 服务，您即将跳转至由 <b>同程旅行</b>（以下简称“第三方”）提供技术支持和运营服务的小程序页面。</p>
          <p style="margin: 2em 0 .1rem 0;">请您在跳转前仔细阅读并充分理解以下事项：</p>
          <p style="font-weight: bold;">1.服务主体变更：</p>
          <p style="text-indent: 2em;">您点击“同意前往预约”后，将离开四川博物院公众号，进入第三方运营的小程序。您在第三方页面进行的购票、支付、预约及售后服务，均由 <b>同程旅行</b> 依据其平台规则及隐私政策为您提供，四川博物院公众号不参与该页面的实际运营及数据处理。</p>
          <p style="font-weight: bold;">2. 个人信息处理：</p>
          <p style="text-indent: 2em;">为实现购票及实名核验功能，第三方平台可能需要收集您的 姓名、身份证号码、手机号码 等个人信息。这些信息将直接由第三方平台按照其隐私政策进行收集和处理，四川博物院公众号不会截留、存储或处理您的上述敏感信息。</p>
          <p style="font-weight: bold;">3.责任声明：</p>
          <p style="text-indent: 2em;">请您在使用第三方服务时，注意保护个人隐私及财产安全。对于因第三方平台服务、数据处理或系统故障导致的任何问题，建议您直接联系<b>同程旅行</b>客服进行咨询和维权。</p>
        </div>
        <div class="btn-group">
          <div class="btn-cancel" @click="agreementVisible=false">取消</div>
          <div class="btn-confirm">
            同意前往预约
             <wx-open-launch-weapp id="launch-btn" :appid="gerData.appid" :path="gerData.path" @launch="onLaunch" @error="errorFun" style="position: absolute;width: 100%;height:100%;left: 0;top:0;z-index:1;">
              <script type="text/wxtag-template">
                <div class="btn" style="position: absolute;width: 100%;height:100%;left: 0;top:0;z-index:1;"></div>
              </script>
            </wx-open-launch-weapp>
          </div>
        </div>
      </div>
    </div>


    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>
<script>
  import P400 from '../../components/P400'
  import {getScenicBanner, getScenicInfo,getToday} from "@/service/getData";
  import {wxGetPosition,wxShareme,wxOpenMapLocation} from '@/utils/wechat'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import {setStore, getStore, removeStore, addJweixin} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)
  import axios from 'axios'



  export default {
    data(){
      const self = this;
      return {
        P400: 0, //系统维护中
        userInfo: {}, //用户信息
        scenicId: this.$route.query.scenicId || '', //景区id
        scenicKey: this.$route.query.scenicKey || '', //来源标记
        swiperCurr:0,
        swiperOption: {
          initialSlide: 0,
          effect: 'fade',
          speed: 500,//切换速度
          watchOverflow: true, //当没有足够的slide切换时，例如只有1个slide（非loop），swiper会失效且隐藏导航等。默认不开启这个功能。
          loop: true,//开启循环模式
//          autoplay: false,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          slidesPerView: 1,
          spaceBetween: 0,
          observeParents:true,
          observer: true,
          preventClicksPropagation: true,//阻止click冒泡。拖动Swiper时阻止click事件。
          simulateTouch: false,//鼠标模拟手机触摸。默认为true，Swiper接受鼠标点击、拖动。
          on: {
            slideChangeTransitionEnd: function () {
              self.swiperCurr = this.activeIndex;
              // 切换结束时，告诉我现在是第几个slide
            }
          }
        },
        scenicInfo: '', //景区基本信息
        banners: [], //景区banner图
        page: 1,
        isOpenToday: '今日开放', //今日是否开发
        wxUrl: '',

        gerData:{
          appid: 'wx336dcaf6a1ecf632',
          path: 'page/top/pages/scenery/detail/detail?bm=bm&sid=799200&wxrefid=2000387136&of=sc00006577&fromtype=13803'
        }, //同程预约订票

        gerData1:{
          appid: 'wx750c50dc0f2bb317',
          path: 'pages/index/index?id=38'
        }, //MR大空间订票
        agreementVisible: false
      }
    },
    computed: {},
    created(){
      if(this.scenicId){
        this.getScenicBannerFun();
        this.getScenicInfoFun();
      }
      this.getOpenState();
      this.getWxUrlLink();
      addJweixin()



    },
    methods: {
      onLaunch(){
        console.log('成功打开小程序')
      },
      errorFun(err) {
        console.log('打开小程序失败', err)
      },
      callback(a){},
      getWxUrlLink() {
        // let url = 'http://vr-venue-api-test.hualiex.com/api/v1/open/scbwy/url-link'; // 测试环境
        let url = 'https://api.aicmeta.com/api/v1/open/scbwy/url-link'; // 正式环境
        axios.get(url).then(res => {
          console.log(res)
          if (res.data.code == 0) {
            this.wxUrl = res.data.data;
          }
        })
      },
      //获取banner数据
      async getScenicBannerFun(){
        let res = await getScenicBanner({
          scenicId: this.scenicId,
          time: (new Date().getTime())
        });
        if (res.errcode == "00000") {
          this.banners = res.data
        }else {
          this.$toast(res.errmsg);
        }
      },

      //获取基本信息
      async getScenicInfoFun(){
        let res = await getScenicInfo({
          scenicId: this.scenicId,
          time: (new Date().getTime())
        })
        if (res.errcode == "00000") {
          this.scenicInfo = res.data
        }else {
          this.$toast(res.errmsg);
        }
      },

      async getOpenState() {
        let res = await getToday({
          scenicId: this.scenicId
        })
        if (res.errcode === '00000') {
          if (res.data.state) {
            this.isOpenToday = "今日开放"
          } else {
            this.isOpenToday = "今日不开放"
          }
        }
        // var d = new Date();
        // var day = ["星期日","星期一","星期二","星期三","星期四","星期五","星期六"];
        // if(day[d.getDay()] == "星期一"){
        //   if(d.getMonth()==9&&d.getDate()<8){
        //     this.isOpenToday = "今日开放"
        //   }else{
        //     this.isOpenToday = "今日暂停开放"
        //   }
        // }else{
        //   this.isOpenToday = "今日开放"
        // }

        let title = '四川博物院 | 门票预约';
        let desc = '欢迎使用四川博物院门票预约服务系统';
        let link = '/order-team-index?scenicId='+this.scenicId+'&scenicKey='+this.scenicKey;
        let img = 'https://filewc.geeker.com.cn//base64_file/20221011/gMHRApee3Ry3ShSScIfnR7JPjL7Umn3cNSUmpb.jpeg';
        wxShareme(title, desc, img, link);
      },

      //地图导航
      openMap: function (){
        wxOpenMapLocation('30.660486', '104.033511', '四川博物院', '四川省成都市青羊区青华路5号')
      },
      toPiao: function(){
        var url = 'http://ticket.zkjxsoft.com/?appid=wxe47c787c774b563e';
        window.open(url,'_blank');
      },
      toPiao1: function(){
        var url = 'http://ticket.zkjxsoft.com/?appid=wxe47c787c774b563e';
        location.href = url;
      },
      toTeam: function(){
        this.$router.push({
          path: `/order-team?${'scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
        });
      },
      toJpjs: function(){
        location.href = 'https://jpjs.geeker.com.cn/dist/index.html#/view-detail-group?shopid=1149'
      },
      toGuide: function(){
        location.href = 'https://jpjs.geeker.com.cn/rest/extral/scenic/JPJSDTxQqwHj1ZIhzQA'
      },
      toActivity: function(){
        location.href = 'https://jpjs.geeker.com.cn/rest/extral/activity/JPJSDTxQqwHj1ZIhzQA'
      },
      toSxd: function () {
        window.location.href = this.wxUrl;
      },
      toMkbl: function () {
        window.location.href = 'https://m.ctrip.com/tangram/MTM2Mjk4?ctm_ref=vactang_page_136298&isHideNavBar=YES&apppgid=10650019968&statusBarStyle=2'
      },
      //永乐宫
      toYlg() {
        window.location.href='https://d.fanzhi.cn/kQYky4hJ'
      }
    },
    watch: {},
    components: {
      P400
    }
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  .page{min-height: 100vh; padding-bottom:.4rem;background-color:#fff;overflow-y: scroll;}
  .swiper-box{position:relative;width: 100vw;height: 3.8rem;overflow: hidden;}
  .swiper-container{width: 100%;height: 100%;}
  .swiper-slide .img{width: 100%;height: 100%;object-fit: cover;}
  .swiper-len{position: absolute;right: .24rem;bottom:.4rem;z-index: 1;height: .44rem;padding:0 .22rem;font:.26rem/.44rem "Microsoft YaHei";color:#fff;background: rgba(0,0,0,.5);border-radius: .22rem;}
  .shaddow{position:relative;z-index:1;width: 100%;height: .24rem;background: #fff;box-shadow: 0 -.12rem .12rem rgba(255,255,255,.9);}

  .item{position:relative;width: 94%;height:1.6rem;margin: 3vw auto 0;border-radius: .08rem;overflow: hidden;}
  .item .item-mask{position: absolute;top: 0;left: 0;right:0;height: 100%;}
  .item:nth-of-type(2n+1) .item-mask{background: linear-gradient(to right,rgba(250, 181, 0, 0) , rgba(255, 181, 0, .6));}
  .item:nth-of-type(2n) .item-mask{background: linear-gradient(to right,rgba(7, 135, 242, 0) , rgba(7, 135, 242, .6));}
  .item:first-child{margin-top: 1vw;}
  .item .txt{position: absolute;right: .24rem;top:50%;z-index:1;text-align:right;font: bold .3rem/.46rem "Microsoft YaHei";color: #fff;letter-spacing: .02rem;-webkit-transform: translateY(-50%);transform: translateY(-50%);}
  .item a{display: block;width: 100%;height: 100%;}

  .alert-order{position: fixed;left: 0;top: 0;z-index:1;width: 100vw;height: 100vh;overflow: hidden;background: #fff;}
 .alert-order .order-con{height: 100%;padding:.24rem .24rem 1.6rem;;overflow-y: scroll;}
  .alert-order .btn-box{position: absolute;left: 0;bottom: 0;width: 100%;background: #fff;border-top: 1px solid #e3e3e3;}
  .alert-order .btn-box .btn{width: 90%;height: .72rem;margin: .14rem auto;line-height: .72rem; }

  /*新样式*/
  .index-banner{width: 100%;height:4.2rem; }
  .spot-info{position:relative;z-index: 1;width:calc(100% - .48rem);height:2.1rem;padding:.3rem;margin: .3rem auto 0;
    box-shadow: 0 .03rem .12rem rgba(0, 0, 0, .19);border-radius: .24rem;background: #fff;color: #222;}
  .spot-info1{margin-top: -.3rem;}
  .spot-info .left{width: 1.5rem;height: 1.5rem;margin-right:.16rem;border-radius: .13rem;border: .01rem solid transparent;}
  .spot-info1 .left{ border: .01rem solid #d9d9d9;background-color: #fff;}
  .spot-info .left img{display: block;width: 100%;height:100%;object-fit: contain;border-radius: .13rem;  }
  .spot-info .right .name{margin-top: .1rem;font: bold .34rem "黑体";}
  .spot-info .right .sub{margin-top:.08rem;font: .24rem/.36rem "黑体";color: #222;}
  .spot-info .right .s1{color: #26a411;}
  .spot-info .right .line{display: inline-block;width: .02rem;height: .24rem;margin: .06rem .08rem;vertical-align: top;background: #999;}
  .spot-info .right .map{margin-top:.12rem;font: .24rem/.36rem "黑体";color: #222;}
  .spot-info .map span{color: #999;}
  .spot-info .map img{width: auto;height: .22rem;margin-top: .06rem;margin-left: .14rem;}

  .spot-info .right1{position: relative;height: 1.5rem;}
  .spot-info .right1 .name{position: absolute;left: .16rem;top:50%;z-index:1;font: bold .34rem/.46rem "黑体";color: #333;letter-spacing: .02rem;-webkit-transform: translateY(-50%);transform: translateY(-50%);}
  .spot-info .right1 .name p{margin-top: .05rem; font-size: .24rem;font-weight: normal;color: #666;}
  .spot-info .right1 .name .txt{ font-size: .24rem; font-weight: 400; color: #666; line-height: .32rem;}
  .spot-info .right1 .bt{position: absolute;right: .3rem;top:50%;z-index:1;padding-right: .3rem; font: normal .24rem "黑体";color: #999;background: url(../../assets/right06.png) no-repeat center right;background-size: auto .2rem;
    -webkit-transform: translateY(-50%);transform: translateY(-50%);}
  /* 第三方跳转提示 */
  .alert-box .alert-con{position: absolute;bottom: 0;left: 0; background: #ffffff;color:#333;border-top-left-radius: .4rem;border-top-right-radius: .4rem;}
  @supports ((padding-bottom: env(safe-area-inset-bottom)) or (padding-bottom: constant(safe-area-inset-bottom))) and (-webkit-overflow-scrolling: touch) {
    .alert-box .alert-con{padding-bottom: calc(.4rem + constant(safe-area-inset-bottom));padding-bottom: calc(.4rem + env(safe-area-inset-bottom));}
  }
  
  .alert-box .tip-title{margin: .32rem; text-align: center;font: bold .34rem/.46rem "黑体";}
  .alert-box .agreement{max-height: 8rem;overflow: auto;line-height: 1.5;padding: 0 .4rem;}
  .alert-box .btn-group{display: flex;border-top: .02rem solid #e5e5e5;padding: .2rem .4rem .2rem .4rem;}
  .alert-box .btn-cancel, .alert-box .btn-confirm{height: .8rem; line-height: .8rem; text-align: center; border-radius: .5rem;}
  .alert-box .btn-cancel{ width: 1.6rem; border: 0.02rem solid #eeeeee;background: #eeeeee;}
  .alert-box .btn-confirm{position: relative;flex: 1;margin-left: .2rem; background: #15a8b7;color: #ffffff;}
  /* .alert-box .btn-cancel{} */
</style>



// WEBPACK FOOTER //
// src/page/home/order-team-index.vue